module.exports = __webpack_public_path__ + "images/iza_small7fb8100be420e61b4a46bd6f7b33b780.png";